import { supabase } from '../lib/supabase'

export async function obtenerCategoriasFinancieras(organizacionId, { tipo, soloActivas = false } = {}) {
  let query = supabase.from('cp_categorias_financieras').select('*').eq('organizacion_id', organizacionId).order('tipo', { ascending: false }).order('orden').order('nombre')
  if (tipo) query = query.eq('tipo', tipo)
  if (soloActivas) query = query.eq('activo', true)
  const { data, error } = await query
  if (error) throw error
  return data ?? []
}

export async function guardarCategoriaFinanciera(organizacionId, values, id = null) {
  const payload = { organizacion_id: organizacionId, tipo: values.tipo, nombre: values.nombre.trim(), orden: Number(values.orden) || 0, activo: values.activo ?? true }
  let query = id
    ? supabase.from('cp_categorias_financieras').update(payload).eq('id', id).eq('organizacion_id', organizacionId)
    : supabase.from('cp_categorias_financieras').insert(payload)
  const { data, error } = await query.select().single()
  if (error) throw error
  return data
}

export async function cambiarEstadoCategoria(organizacionId, id, activo) {
  const { data, error } = await supabase.from('cp_categorias_financieras').update({ activo }).eq('id', id).eq('organizacion_id', organizacionId).select().single()
  if (error) throw error
  return data
}
